<script lang="ts">
import { ChatContext, ChatContextType } from '@/types/chat';
import {
  iButton,
  iButtonStyles,
  iButtonTypes,
  iButtonSizes,
  iKeyIcon,
  iKeyIconShape,
  iKeyIconType,
  iKeyIconStyle,
  iKeyIconSize,
} from '@inscribe/signal';
import { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'ChatPanelSuggestedPrompt',
  components: { iButton, iKeyIcon },
  props: {
    prompt: {
      type: Object,
      required: true,
    },
    contexts: {
      type: Array as PropType<ChatContext[]>,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['currentConversationUuid']),
  },
  setup() {
    return {
      iButtonStyles,
      iButtonTypes,
      iButtonSizes,
      iKeyIconShape,
      iKeyIconType,
      iKeyIconStyle,
      iKeyIconSize,
    };
  },
  methods: {
    ...mapActions(['submitConversationMessage']),
    onPromptClick() {
      const customerContext = this.contexts.find(
        (context) => context.type === ChatContextType.Customer,
      );
      const documentContext = this.contexts.find(
        (context) => context.type === ChatContextType.Document,
      );
      const contextCustomerUuids = customerContext
        ? [customerContext.customerUuid]
        : [];
      const contextDocumentIds = documentContext
        ? [documentContext.documentId]
        : [];
      this.submitConversationMessage({
        conversationUuid: this.currentConversationUuid,
        userMessageContent: this.prompt.prompt,
        contextCustomerUuids,
        contextDocumentIds,
      });
    },
  },
};
</script>

<template>
  <div
    class="chat-panel-suggested-prompt i-p-6 d-flex align-items-center i-gap-6"
    @click="onPromptClick"
  >
    <i-key-icon
      icon="medium-search"
      :shape="iKeyIconShape.SQUARE"
      :type="iKeyIconType.NEUTRAL"
      :size="iKeyIconSize.XS"
      :icon-style="iKeyIconStyle.OUTLINE"
    />
    <div class="prompt-text d-flex flex-column">
      <div class="title i-text-subheading-2">{{ prompt.prompt }}</div>
    </div>
    <i-button
      right-icon="medium-chevron-right"
      :size="iButtonSizes.SMALL"
      :type="iButtonTypes.NEUTRAL"
      :button-style="iButtonStyles.GHOST"
      class="i-ml-9"
      @button-click="onPromptClick"
    />
  </div>
</template>

<style lang="scss" scoped>
.chat-panel-suggested-prompt {
  background: var(--surface-neutral-subtle);
  cursor: pointer;

  &:hover {
    background: var(--surface-neutral);
  }

  .prompt-text {
    flex: 1;

    .title {
      color: var(--text-neutral-bold);
      font-weight: normal;
    }
  }
}
</style>
